import {
  NavLink
} from "react-router-dom";
import { withTheme } from '@emotion/react'
import styled from '@emotion/styled/macro';
import React, { useContext } from 'react';
import facebook from '../assets/images/icons/social/facebook.svg';
import instagram from '../assets/images/icons/social/instagram.svg';
import linkedin from '../assets/images/icons/social/linkedin.svg';
import twitter from '../assets/images/icons/social/twitter.svg';
import youtube from '../assets/images/icons/social/youtube.svg';
import phone from '../assets/images/icons/social/phone.svg';
import email from '../assets/images/icons/social/email.svg';
import chat from '../assets/images/icons/social/chat.svg';
import EnvContext from '../EnvContext';

const FooterContainer = styled.div`
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  min-height: 200px;
  padding: ${props => props.theme.margins.std};


  @media (min-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: row;
    justify-content: space-between;
    margin: 0 auto;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}) {

  }
`;

const StyledFooter = styled.footer`
  background: ${props => props.theme.colors.primary4};
  color: ${props => props.theme.colors.contrast2};  
  display: flex; 
  flex-direction: column;
  font-family: ${props => props.theme.fonts.primary};
  font-size: ${props => props.theme.fontSizes.std};
  justify-content: center;

  @media (min-width: ${props => props.theme.breakpoints.lg}) {

  }
`;

const FooterGroup = styled.div`
  margin-bottom: 64px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    margin-bottom: 0;
    margin-left: 80px;
    &:nth-of-type(1) {
      margin-left: 0;
    }
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    min-width: 140px;
    margin-bottom: 0;
    margin-left: 60px;
    &:nth-of-type(1) {
      margin-left: 0;
    }
  }
`;

const ListHeader = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.contrast2};  
  font-weight: bold;
  letter-spacing: 1px;
  padding-bottom: 12px;
  text-transform: uppercase;
  font-size: ${props => props.theme.fontSizes.sm};
`;

const StyledList = styled.ul`

`;

const StyledItem = styled.li`
  padding-top: 20px;
`;

const StyledLink = styled(NavLink)`
  color: ${props => props.theme.colors.contrast2};
  font-family: ${props => props.theme.fonts.secondary};
  text-decoration: none;
  font-size: ${props => props.theme.fontSizes.xs};
`;

const SocialContainer = styled.div`
  display: flex;
  background-color: #0A6078;
  width: 100%;
  padding: 35px;
`;

const StyledAnchor = styled.a`
  color: ${props => props.theme.colors.contrast2};
  font-family: ${props => props.theme.fonts.secondary};
  text-decoration: none;
  font-size: ${props => props.theme.fontSizes.xs};
`;

const SocialWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: row;
    max-width: 740px;
    margin: 0 auto;
  }
`;

const SocialGroup = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  &:nth-of-type(1) {
    margin-bottom: 40px;
  }


  @media (min-width: ${props => props.theme.breakpoints.md}) {
    
    &:nth-of-type(1) {
      margin-bottom: 0px;
      justify-content: flex-start;

      a {
        margin-right: 20px;
      }
    }

    &:nth-of-type(2) {
      justify-content: flex-end;

      a {
        margin-left: 20px;
      }
    }
  }
`;

const ChatContainer = styled.div`
  background: ${props => props.theme.colors.primary4};
  padding: 40px;
`;

const ChatWrapper = styled.div`
  background-color: #055166;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: row;
    justify-content: flex-start;
    max-width: 800px;
    margin: 0 auto;
  }
`;

const ChatHeader = styled.div`
  font-family: ${props => props.theme.fonts.primary};
  font-weight: bold;
  padding: 20px;
  border-color: #0A6078;
  border-style: solid;
  border-width: 0 0 1px;
  text-align: left;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    border-width: 0 1px 0 0;
    padding-left: 0px;
    padding-right: 0px;
    margin-right: 20px;
    max-width: 100px;
    line-height: 26px;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    border-width: 0 1px 0 0;
    padding-left: 10px;
    padding-right: 40px;
    margin-right: 40px;
    max-width: unset;
    line-height: unset;
  }
`;

const ChatTitle = styled.div`
  padding-bottom: 12px;
  font-size: ${props => props.theme.fontSizes.sm};
  font-weight: bold;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    display: flex;
    align-items: center;
  }
`;

const ChatWrap = styled.a`
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  cursor: pointer;
  color: ${props => props.theme.colors.contrast2};
  font-family: ${props => props.theme.fonts.secondary};
  text-decoration: none;

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    padding-top: 0px;

    &:nth-of-type(1) {
      padding-right: 40px;
    }
  }
`;

const ChatImg = styled.img`
  align-self: flex-start;
  padding-right: 12px;

  @media (min-width: ${props => props.theme.breakpoints.md}) {

  }
`;

const ChatLink = styled.span`
  font-size: ${props => props.theme.fontSizes.xs};
`;

const ChatText = styled.div`
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    padding-top: 4px;
  }
`;

const PureChat = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  cursor: pointer;
  color: ${props => props.theme.colors.contrast2};
  font-family: ${props => props.theme.fonts.secondary};
  text-decoration: none;
  padding-left: 0;
  text-align: left;

  ${ChatText} {
    padding-top: 0;
  }

  ${ChatTitle} {
    padding-bottom: 8px;
  }

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    padding-top: 0px;

    &:nth-of-type(1) {
      padding-right: 40px;
    }
  }
`;

function Footer() {
  const { envBaseUrl } = useContext(EnvContext);

  function togglePureChat() {
    if (!!window.purechatApi.get('chatbox.expanded')) {
      window.purechatApi.set('chatbox.expanded', false);
      window.purechatApi.set('chatbox.visible', false);
    } else {
      window.purechatApi.set('chatbox.expanded', true);
      window.purechatApi.set('chatbox.visible', true);
    }
  }

  return (
      <StyledFooter>
        <FooterContainer>
          <FooterGroup>
            <ListHeader>Patients</ListHeader>
            <StyledList>
              <StyledItem>
                <StyledLink to="/">Find the Right Study</StyledLink>
              </StyledItem>
              <StyledItem>
                <StyledLink to="/patients/what-are-clinical-trials">About Clinical Trials</StyledLink>
              </StyledItem>
              <StyledItem>
                <StyledLink to="/patients/what-is-studykik">How StudyKIK Helps</StyledLink>
              </StyledItem>
            </StyledList>
          </FooterGroup>
          <FooterGroup>
            <ListHeader>Sites</ListHeader>
            <StyledList>
              <StyledItem>
                <StyledLink to="/sites/recruitment">Patient Recruitment</StyledLink>
              </StyledItem>
              <StyledItem>
                <StyledLink to="/sites/portal">KIKSite Platform</StyledLink>
              </StyledItem>
              <StyledItem>
                <StyledLink to="/sites/plans">Enrollment Plans</StyledLink>
              </StyledItem>
            </StyledList>
          </FooterGroup>
          <FooterGroup>
            <ListHeader>Sponsors</ListHeader>
            <StyledList>
              <StyledItem>
                <StyledLink to="/sponsors/recruitment-retention">Recruitment & Retention</StyledLink>
              </StyledItem>
              <StyledItem>
                <StyledLink to="/sponsors/econsent">eConsent</StyledLink>
              </StyledItem>
              <StyledItem>
                <StyledLink to="/sponsors/apps">Study Companion Apps</StyledLink>
              </StyledItem>
              <StyledItem>
                <StyledLink to="/sponsors/trial-reporting">Trial Reporting</StyledLink>
              </StyledItem>
            </StyledList>
          </FooterGroup>
          <FooterGroup>
            <ListHeader>Our Company</ListHeader>
            <StyledList>
              <StyledItem>
                <StyledLink to="/about">About Us</StyledLink>
              </StyledItem>
              <StyledItem>
                <StyledLink to="/contact">Contact</StyledLink>
              </StyledItem>
            </StyledList>
          </FooterGroup>
        </FooterContainer>
        <ChatContainer>
          <ChatWrapper>
            <ChatHeader>Want to Chat?</ChatHeader>
            <ChatWrap href="mailto:info@studykik.com">
              <ChatImg src={email} />
              <ChatText>
                <ChatTitle>Email Us</ChatTitle>
                <ChatLink>info@studykik.com</ChatLink>
              </ChatText>
            </ChatWrap>
            <PureChat type="button" onClick={togglePureChat}>
              <ChatImg src={chat} />
              <ChatText>
                <ChatTitle>Chat with us</ChatTitle>
                <ChatLink>Mon–Fri, 5am–10pm PT</ChatLink>
              </ChatText>
            </PureChat>
            <ChatWrap href="tel:8776272509">
              <ChatImg src={phone} />
              <ChatText>
                <ChatTitle>Call us</ChatTitle>
                <ChatLink>877-627-2509</ChatLink>
              </ChatText>
            </ChatWrap>
          </ChatWrapper>
        </ChatContainer>
        <SocialContainer>
          <SocialWrapper>
            <SocialGroup>
              <a target="_blank" href="https://www.facebook.com/StudyKIK/" rel="noreferrer"><img src={facebook}  alt="facebook" /></a>
              <a target="_blank" href="https://twitter.com/studykik" rel="noreferrer"><img src={twitter} alt="twitter" /></a>
              <a target="_blank" href="https://www.instagram.com/studykik/" rel="noreferrer"><img src={instagram}  alt="instagram" /></a>
              <a target="_blank" href="https://www.youtube.com/c/Studykik" rel="noreferrer"><img src={youtube}  alt="youtube" /></a>
              <a target="_blank" href="https://www.linkedin.com/company/studykik" rel="noreferrer"><img src={linkedin} alt="linkedin" /></a>
            </SocialGroup>
            <SocialGroup>
              <StyledAnchor target="_blank" href={`${envBaseUrl}/privacy-policy`}>Privacy Policy</StyledAnchor>
              <StyledAnchor target="_blank" href={`${envBaseUrl}/terms-of-service`}>Terms Of Use</StyledAnchor>
              <StyledAnchor target="_blank" href={`${envBaseUrl}/cookie-policy`}>Cookie Policy</StyledAnchor>
            </SocialGroup>
          </SocialWrapper>
        </SocialContainer>
      </StyledFooter>
  );
}

export default withTheme(Footer);